import { Data } from 'signup-constants/signupData/Data';
export const OptionalDataKeys = [Data.OptionalPhoneNumber];